export interface GridLoadParams {
  skip?: number
  take?: number
  sort?: string
  filter?: string
  grid?: string
}

export interface GridLoadResult<T = any> {
  data: T[]
  totalCount: number
}

export function buildGridLoadParams(loadOptions: any, extra: Record<string, any> = {}): GridLoadParams {
  const params: GridLoadParams = {
    skip: loadOptions.skip || 0,
    take: loadOptions.take || 25,
    ...extra
  }

  if (loadOptions.sort) {
    params.sort = JSON.stringify(loadOptions.sort)
  }

  if (loadOptions.filter) {
    params.filter = JSON.stringify(loadOptions.filter)
  }

  return params
}

export function normalizeGridResponse<T = any>(payload: any): GridLoadResult<T> {
  return {
    data: payload?.data || [],
    totalCount: payload?.totalCount || 0
  }
}
